var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconPrevious = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", style: { transform: "rotate(180deg)" } }, { children: [_jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.29246 6.70998C6.68246 6.31998 7.31246 6.31998 7.70246 6.70998L12.2925 11.3C12.6825 11.69 12.6825 12.32 12.2925 12.71L7.70246 17.3C7.31246 17.69 6.68246 17.69 6.29246 17.3C5.90246 16.91 5.90246 16.28 6.29246 15.89L10.1725 12L6.29246 8.11998C5.90246 7.72998 5.91246 7.08998 6.29246 6.70998Z" }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.2925 6.70998C11.6825 6.31998 12.3125 6.31998 12.7025 6.70998L17.2925 11.3C17.6825 11.69 17.6825 12.32 17.2925 12.71L12.7025 17.3C12.3125 17.69 11.6825 17.69 11.2925 17.3C10.9025 16.91 10.9025 16.28 11.2925 15.89L15.1725 12L11.2925 8.11998C10.9025 7.72998 10.9125 7.08998 11.2925 6.70998Z" })] })) })));
};
export default IconPrevious;
